module.exports = __webpack_public_path__ + "assets/media/s24.37723e21.mp3";